import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './assets/css/tailwind.css';
import './assets/css/material.css';
import ScrollToTop from './components/scroll-to-top';
import Switcher from './components/switcher';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'; // Kendi i18n yapılandırmanız

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <I18nextProvider i18n={i18n}>
      <App /> {/* Navbar, App içinde yer almalı */}
    </I18nextProvider>
    <ScrollToTop />
    <Switcher />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
